// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KI13a","textarea":"styles_textarea__2ax8j"};